// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2QCf_","inputWrap":"CustomTip_inputWrap__ECHWz"};